const locationTarget = {
  type: "svg",
  props: {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  },
  metadata: {
    description: "Analyzes current location.",
    usage: "",
    category: "Maps",
    tags: ["map"]
  },
  children: [{
    type: "path",
    props: {
      d: "M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0zm1.442.999a8.504 8.504 0 0 1-7.443 7.443l.001.052v1.512A.994.994 0 0 1 12 23c-.552 0-1-.458-1-.994v-1.512l.001-.052a8.504 8.504 0 0 1-7.443-7.443.961.961 0 0 1-.052.001H1.994A.994.994 0 0 1 1 12c0-.552.458-1 .994-1h1.512l.052.001a8.504 8.504 0 0 1 7.443-7.443.961.961 0 0 1-.001-.052V1.994A.994.994 0 0 1 12 1c.552 0 1 .458 1 .994v1.512l-.001.052a8.504 8.504 0 0 1 7.443 7.443.961.961 0 0 1 .052-.001h1.512c.55 0 .994.444.994 1 0 .552-.458 1-.994 1h-1.512l-.052-.001zM12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z"
    }
  }]
};
export default locationTarget;